module.exports = __webpack_public_path__ + "img/alfie-m10.4b89d2fa.jpeg";